import { ConcreteEncodable } from "./ConcreteEncodable";

import { FixingEventImplEncoder } from "../../encoder/FixingEventImplEncoder";

import * as CubiqTS from "../../index";
import { FixingEvent } from "../FixingEvent";

export class FixingEventImpl extends ConcreteEncodable implements FixingEvent {
  public static enType: string = "com.bcdfx.model.event.lifecycle.fx.FixingEventImpl";

  /*FID=1*/
  public fixingState: CubiqTS.FixingState;
  /*FID=2*/
  public bMTimeCodes: Array<CubiqTS.BMTimeCode> | null = null;
  /*FID=3*/
  public expiringOrderIds: Array<CubiqTS.Long> | null = null;
  /*FID=4*/
  public lastRevalTime: CubiqTS.moment.Moment | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FixingEventImplEncoder.Instance;
    this.setEncodableType(FixingEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FixingEventImpl[" +
      "fixingState=" +
      this.fixingState +
      "bMTimeCodes=" +
      this.bMTimeCodes +
      "expiringOrderIds=" +
      this.expiringOrderIds +
      "lastRevalTime=" +
      this.lastRevalTime +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
